import * as React from "react"
import {Box} from "@mui/material"
import { AmchartSeeker, ModalSeeker } from "@ui-seeker/core"

import {evolutionSelection, kpiSelected} from "../@signals";
import ProductPageKPIEvolutionChartToolbar from "./Toolbar";
import {useProductPagesKpiEvolution} from "./@hooks";


export default function ProductPageKPIEvolutionChart() {
    const {resetEvolutionData, isLoadingDataEvolution, dataEvolution, selectData, dateRange, onChange} = useProductPagesKpiEvolution()

    if (!dataEvolution?.length || isLoadingDataEvolution) return <></>
  
    return <ModalSeeker 
        hideActions 
        isOpen={!!dataEvolution?.length} 
        title={`Product Page KPI Evolution - ${evolutionSelection.value}`} 
        controller={() => resetEvolutionData()}
        containerProps={{
            maxWidth:"xl"
        }}
    >
        <AmchartSeeker
            data={dataEvolution}
            title={<Box id="evolution-price-chart"></Box>}
            pdfProps={{
                titlePDF:`Product Page KPI Evolution - ${evolutionSelection.value}`
            }}
            series={[{
                name: selectData.filter(item => item.value === kpiSelected.value)[0]?.label,
                yField: kpiSelected.value,
                xField: "date",
                connect: true,
            }]}
            chartProps={{
                numberFormat: `#,###.##'%'`,
                dateFormatReceived: 'yyyyMMdd',
                xAxis: {
                    categoryField: 'date',
                    isDateAxis: true,
                    dateFormat: 'dd MMM yyyy',
                    baseInterval: {
                        timeUnit: 'day',
                        count: 1
                    }
                },
                yAxis: {
                    numberFormat: `#,###.##'%'`
                }
            }}
            cardProps={{ actions: <ProductPageKPIEvolutionChartToolbar options={selectData} dateRange={dateRange} onChange={onChange} /> }}
            sx={{ height: 500 }}
        />
    </ModalSeeker>
}